export default "__VITE_ASSET__CYNIsihD__"